import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {Component, OnInit, Inject} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {MatChipInputEvent} from '@angular/material/chips';
import {UntypedFormGroup, UntypedFormControl} from '@angular/forms';
import {Opcion} from 'src/app/model/opcion';
import {functionUtil} from 'src/app/util/functionConst';
import {ParametrosConst} from 'src/app/util/parametrosConst';
import {IntranetService} from 'src/app/intranet/intranet.service';
import {AlertaService} from 'src/app/util/alerta.service';

@Component({
  selector: 'sura-registro-opcion-dialog',
  templateUrl: './registro-opcion-dialog.component.html'
})
export class RegistroOpcionDialogComponent {
  public regOpcionForm: UntypedFormGroup;
  maxCaracteresInicial: number = ParametrosConst.maxCaracteresPlantilla;
  maxCaracteres: number = this.maxCaracteresInicial;
  maxOpcionesPermitidas: number = ParametrosConst.maxOpcionesPermitidas;
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  opciones: Opcion[] = [];
  fnInputMaxLength = functionUtil.fnInputMaxLength;

  constructor(public dialogRef: MatDialogRef<RegistroOpcionDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: {},
              private intranetService: IntranetService,
              private alertaService: AlertaService) {
    this.regOpcionForm = new UntypedFormGroup({
      plantillaOpcion: new UntypedFormControl('')
    });
  }

  guardarPlantilla() {
    this.intranetService.guardarPlantilla(this.getPlantilla()).then(respuesta => {
      this.alertaService.success(respuesta);
      this.closeModal(true);
    }).catch(error => {
      this.alertaService.error(error);
    });
  }

  closeModal(_indSuccess: boolean): void {
    this.dialogRef.close(_indSuccess);
  }

  getPlantilla(): string {
    let _plantillaOpcion = '';
    for (let index = 0; index < this.opciones.length; index++) {
      _plantillaOpcion += this.opciones[index].descripcion.trim();
      if (this.opciones.length - 1 > index) {
        _plantillaOpcion += ',';
      }
    }
    return _plantillaOpcion;
    // this.dialogRef.close(this.opciones);
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
    // Add our fruit
    if ((value || '').trim()) {
      const newOp = new Opcion();
      newOp.descripcion = value;
      this.opciones.push(newOp);
    }
    // Reset the input value
    if (input) {
      input.value = '';
    }
    this.calcularCaracteresRestantes();
  }

  remove(opcion: Opcion): void {
    const index = this.opciones.indexOf(opcion);
    if (index >= 0) {
      this.opciones.splice(index, 1);
      this.calcularCaracteresRestantes();
    }
  }

  calcularCaracteresRestantes() {
    let caracteresUtilizados = 0;
    let totalComas = 0;
    if (this.opciones.length >= 2) {
      totalComas = this.opciones.length - 1;
    } else {
      totalComas = 0;
      this.maxCaracteres = this.maxCaracteresInicial;
    }
    this.opciones.forEach(opcion => {
      caracteresUtilizados += opcion.descripcion.trim().length;
    });
    // se agrega un caracteres adicional para la coma final
    this.maxCaracteres = this.maxCaracteresInicial - (caracteresUtilizados + totalComas + 1);
    if (this.maxCaracteres < 0 || ParametrosConst.maxOpcionesPermitidas <= this.opciones.length) {
      this.maxCaracteres = 0;
    }
  }

  validarPlantilla() {
    return this.opciones.length <= ParametrosConst.maxOpcionesPermitidas && this.opciones.length > 0;
  }
}
